import { NoPermissionMessagePortfolioPage } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.contants';
import {
    IHashmapItemWithCustomProps,
    IPortfolioProps,
} from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';

export const overallStatus: IHashmapItemWithCustomProps<IPortfolioProps> = {
    NoPermissionMessage: NoPermissionMessagePortfolioPage,
    titleWithoutProjectAndContract: 'Portfolio',
    permission: 'PortfolioPage',
};
